<span class="alert alert-danger" [class._noSpace]="noSpace" [class._hollow]="hollow"><ng-content></ng-content></span>
